module.exports = __webpack_public_path__ + "static/credpal-logo-887e3bddfcd6fa07fd82c8a5f050c5cc.svg";